import { Injectable } from '@angular/core';
import { WilsonState } from '@wilson/non-domain-specific/decorators/wilson-state';
import { ShiftValidationDetails } from '@wilson/interfaces';
import { Observable } from 'rxjs';
import {
  ShiftId,
  TimelineShiftValidationsStateServiceBase,
} from './timeline-shift-validations-state.service.base';

@Injectable({
  providedIn: 'root',
})
export class TimelineAssignedShiftValidationsStateService extends TimelineShiftValidationsStateServiceBase {
  @WilsonState<Set<ShiftId>>(new Set())
  override shiftValidationLoadingIds!: Set<ShiftId>;
  override shiftValidationLoadingIds$!: Observable<Set<ShiftId>>;

  @WilsonState<Record<ShiftId, ShiftValidationDetails[]>>({})
  override shiftValidationsRecord!: Record<ShiftId, ShiftValidationDetails[]>;
  override shiftValidationsRecord$!: Observable<
    Record<ShiftId, ShiftValidationDetails[]>
  >;
}
